
export type ModalButtonSeverity = number;
export let ModalButtonSeverity: any = {};
ModalButtonSeverity.Primary = 0;
ModalButtonSeverity.Warn = 1;
ModalButtonSeverity.Normal = 2;
ModalButtonSeverity.Success = 3;
ModalButtonSeverity[ModalButtonSeverity.Primary] = "Primary";
ModalButtonSeverity[ModalButtonSeverity.Warn] = "Warn";
ModalButtonSeverity[ModalButtonSeverity.Normal] = "Normal";
ModalButtonSeverity[ModalButtonSeverity.Success] = "Success";
